// extracted by mini-css-extract-plugin
export default {"BelowBackground":"ContactBelow_BelowBackground__6yt7K","cardBody":"ContactBelow_cardBody__LNkYi","svg":"ContactBelow_svg__7ZHFg"};